import { render, staticRenderFns } from "./BI.vue?vue&type=template&id=1496a7b0&"
import script from "./BI.vue?vue&type=script&lang=js&"
export * from "./BI.vue?vue&type=script&lang=js&"
import style0 from "./BI.vue?vue&type=style&index=0&id=1496a7b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports